import React from 'react';
import { Table, TableProps, TableRowProps } from 'semantic-ui-react';

const SizeTable = ({
  headerRows,
  tableData,
  semanticUIprops,
}: {
  headerRows: null | ((string | JSX.Element)[] | null)[];
  tableData: TableRowProps[] | null;
  semanticUIprops?: TableProps;
}) => {
  const renderBodyRow = (row: TableRowProps, i: number) => {
    const { name, ...rest } = row;
    const values = Object.values(rest);
    const valueCells = values.map((value, idx) => {
      return {
        key: value + idx,
        content: value,
        'data-cellindex': idx + 1,
        tabIndex: 0,
        onMouseOver: (e: React.MouseEvent) => {
          handleVerticalHoverEffect(e);
        },
      };
    });
    return {
      key: name || `row-${i}`,
      'data-rowindex': i,
      cells: [{ content: name, key: name, tabIndex: 0 }, ...valueCells],
    };
  };

  // Fancy hover | Vertical part. Horizontal part is handled by CSS
  // ? [REVISIT] Had no time for sophisticated implementation. Feel free to provide another implementation
  const handleVerticalHoverEffect = (e: React.MouseEvent) => {
    const relatedCells = Array.from(document.querySelectorAll('.related-cell'));
    relatedCells.forEach((cell) => cell.classList.remove('related-cell'));
    const hoveredCell = e.currentTarget as HTMLElement;
    const { cellindex } = hoveredCell.dataset;
    const row = hoveredCell.parentElement;
    if (row?.parentElement) {
      const table = row.parentElement.closest('table');
      const headerRows = table?.querySelectorAll('thead tr');
      const { rowindex } = row?.dataset;
      if (headerRows && headerRows.length) {
        headerRows.forEach((headerRow) => {
          const relatedHeaderCell = headerRow && Array.from(headerRow.children)[Number(cellindex)];
          if (relatedHeaderCell) relatedHeaderCell.classList.add('related-cell');
        });
        Array.from(row.parentElement.children).forEach((child, idx) => {
          if (idx < Number(rowindex)) {
            const relatedCell = Array.from(child.children)[Number(cellindex)];
            relatedCell?.classList.add('related-cell');
          }
        });
      }
    }
  };

  const clearHover = () => {
    const relatedCells = Array.from(document.querySelectorAll('.related-cell'));
    relatedCells.forEach((cell) => cell.classList.remove('related-cell'));
  };

  return tableData && headerRows ? (
    <div className="table-wrapper">
      <Table
        celled
        unstackable
        basic
        className={`size-table`}
        renderBodyRow={renderBodyRow}
        headerRows={headerRows}
        tableData={tableData}
        onMouseLeave={clearHover}
        {...semanticUIprops}
      />
    </div>
  ) : null;
};

export default SizeTable;
